import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import WithAuthRedirect from '@/_navigation/hocs/with-public-route';

const InstructorLogin = lazyRouteComponent(() => import('@/_instructor/login'));

export const Route = createFileRoute('/_public/login')({
  component: () => <WithAuthRedirect component={InstructorLogin} />,
});
